import {
	captureCampaignFromRoute,
	refreshCampaignActivity
} from '~/composables/adCampaign/utils';
import { refreshLastSrpUrlActivity } from '~/composables/lastSrpUrl/utils';
import { refreshSessionActivity } from '~/composables/visitorIdentity/utils';

export default defineNuxtRouteMiddleware(to => {
	if (import.meta.client) {
		// During hydration `to` is resolved from the SSR payload path, which on a
		// CDN-cached route can carry another visitor's campaign params. The landing
		// URL is captured from `window.location` by plugins/campaign.client.ts, so
		// capturing here again would only reintroduce that poisoning.
		if (!useNuxtApp().isHydrating) {
			captureCampaignFromRoute(to);
		}

		refreshCampaignActivity();
		refreshLastSrpUrlActivity();
		refreshSessionActivity();
	}
});
